export default __webpack_public_path__ + "static/data-about-screenshot-2--mobile-deb8c1012e83aa96ead86f52b44f12e5.png";